export enum ENotificationTypes {
  'line' = 'line',
  'application' = 'application',
}

export interface INotificationWithId extends INotification {
  id: string;
}

export interface INotification {
  type: ENotificationTypes;
  lineId?: string;
  message: string;
  learnMoreMessage: object | string;
  icon: string;
  action?: { name: string; onClick: (...args) => any };
}

export interface INotificationContext {
  notifications: Array<INotificationWithId>;
  addNotification: (...args: Array<INotification>) => any;
  removeNotification: (...args) => any;
}
